import React from "react";
import "./App.css";
import Blogs from "./components/Blogs/Blogs";

function App() {
  return (
    <div className="App">
      <Blogs />
    </div>
  );
}

export default App;
